
export const formattedDate = (timestamp) => {
    const date = new Date(timestamp);
    return (
        <span>
            {
                date.toLocaleDateString('fr-FR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                })
            }
        </span>
    );

}

export const formatDatePaymentLinkToSend = (date) => {
    if (!date) return;

    return date.format('YYYY-MM-DDTHH:mm:ss');

}


export const formatDatePaymentLink = (datetime) => {
    return datetime.split('T')[0];
}

export const buttonStatusFilter = [
    { label: 'Tous', value: 'ALL' },
    { label: 'Payés', value: 'SUCCESS' },
    { label: 'Non payés', value: 'UNPAID' },
    { label: 'Expirés', value: "EXPIRED" }
]

const filterPaymentLinkByStatus = (data, status) => {
    return data.filter(item => item.paymentStatus == status);
}

const filterPaymentLinkByAmount = (data, minAmount, maxAmount) => {
    return data.filter(item => {
        return item.amount >= minAmount && item.amount <= maxAmount;
    });
}

export const mainFilterPaymentLink = (data, status, minAmount, maxAmount) => {
    let paymentLinks = data || [];
    let paymentLinksAfterStatusFilter = [];
    let paymentLinksAfterAmountFilter = [];

    if (status != null) {
        paymentLinksAfterStatusFilter = filterPaymentLinkByStatus(paymentLinks, status);
    } else {
        paymentLinksAfterStatusFilter = paymentLinks;
    }

    if (minAmount != null && maxAmount != null) {
        paymentLinksAfterAmountFilter = filterPaymentLinkByAmount(paymentLinksAfterStatusFilter, minAmount, maxAmount);
    } else {
        paymentLinksAfterAmountFilter = paymentLinksAfterStatusFilter;
    }

    return paymentLinksAfterAmountFilter;

}

export const filterPaymentLink = (data, status, minAmount = 0, maxAmount = Infinity) => {
    return data.filter(item => {
        const statusMatch = status == 'ALL' || item.paymentStatus == status;

        const amount = item.amount;

        const minMatch = minAmount != null ? amount >= minAmount : true;
        const maxMatch = maxAmount != null ? amount <= maxAmount : true;

        return statusMatch && minMatch && maxMatch;
    });
}
